import { AcknowledgementLinePreviewContainer } from "components/Preferences/AcknowledgementLinePreview.styles.ts";
import { AcknowledgementPriceFormatType, AcknowledgmentEmailFormatType } from "types/declarations/enums.ts";

export interface AcknowledgementLinePreviewProps {
	priceType: AcknowledgementPriceFormatType | undefined;
	layout: AcknowledgmentEmailFormatType | undefined;
}

const AcknowledgementLinePreview = ({ priceType, layout }: AcknowledgementLinePreviewProps) => {
	return (
		<AcknowledgementLinePreviewContainer key={`${layout}_${priceType}`}>
			<img
				src={`/assets/acknowledgements/${layout}_${priceType}.svg`}
				alt={`Line Item Preview - ${layout} ${priceType} `}
			/>
		</AcknowledgementLinePreviewContainer>
	);
};

export default AcknowledgementLinePreview;
